import { IngredientFormData, IngredientValidationError } from '../types/ingredient';

const CANNABINOID_FIELDS = ['thc', 'thca', 'cbd', 'cbda', 'cbg', 'cbn'] as const;

/**
 * Validates an ingredient form data object and returns an array of validation errors.
 * Checks name (required, 1–100 chars after trim, non-whitespace-only),
 * brand/strain (optional, max 100 chars), and cannabinoid fields
 * (optional, must be numeric 0.00–100.00 if provided).
 */
export function validateIngredientForm(data: IngredientFormData): IngredientValidationError[] {
  const errors: IngredientValidationError[] = [];

  // Name validation: required, 1–100 chars after trim, non-whitespace-only
  const trimmedName = data.name.trim();
  if (trimmedName.length === 0) {
    errors.push({
      field: 'name',
      message: 'Name is required',
    });
  } else if (trimmedName.length > 100) {
    errors.push({
      field: 'name',
      message: 'Name must be 100 characters or fewer',
    });
  }

  // Brand validation: optional, max 100 chars
  if (data.brand.length > 100) {
    errors.push({
      field: 'brand',
      message: 'Brand must be 100 characters or fewer',
    });
  }

  // Strain validation: optional, max 100 chars
  if (data.strain.length > 100) {
    errors.push({
      field: 'strain',
      message: 'Strain must be 100 characters or fewer',
    });
  }

  // Cannabinoid fields validation: optional, if provided must be numeric and 0.00–100.00
  for (const field of CANNABINOID_FIELDS) {
    const value = data[field];
    if (value === '') {
      continue; // empty string means not provided
    }

    const parsed = parseFloat(value);
    if (isNaN(parsed) || !isFinite(parsed)) {
      errors.push({
        field,
        message: 'Must be a valid number',
      });
    } else if (parsed < 0 || parsed > 100) {
      errors.push({
        field,
        message: 'Must be between 0 and 100',
      });
    }
  }

  return errors;
}
